import { createStore, combineReducers } from "redux";
import { globalReducer } from "./reducers/globalReducer";

const allReducers = combineReducers({ global: globalReducer });

const store = createStore(allReducers);
export default store;
